/**
 * /cli/device（デバイスコードでのログイン・pages/CliDevice.tsx）の英語の文言（2026-10-07 console/device-login）。en.ts が `...enCliDevice` で取り込む
 * （ja.cliDevice.ts が同じキーを全部持つことを型で強制）。
 * 決め事（指示書）: 普通の人が読んで迷わない文。「チャットかターミナルに出た文字と同じなら Allow」だけを言う。
 * 「自分で頼んでいないなら Cancel」の 1 行は CliAuthorize と同じ cliAuth.safety を使う（ここには置かない）。
 * 「chat」= 利用者と AI の会話（閉じた機能のチャットではない・wordsPass.test.ts の ALLOWED に理由）
 */
export const enCliDevice = {
  'cliDevice.title': 'Sign in with this code?',
  'cliDevice.lead': 'Check that this code is the same as the one in your chat or terminal. If it is the same, press Allow.',
  // 端末の名前は CLI の申告（偽れる）= 「名乗った名前」と分かる書き方（cliAuth.device と同じ考え）
  'cliDevice.device': 'Computer (as it named itself): {device}',
  'cliDevice.allow': 'Allow',
  'cliDevice.unverifiedThen': 'After confirming your email, reload this page to sign in.',
  'cliDevice.allowedTitle': 'Done',
  'cliDevice.allowedBody': 'You are signed in. You can close this tab and go back to the chat or terminal.',
  'cliDevice.cancelledTitle': 'Cancelled',
  'cliDevice.cancelledBody': 'You were not signed in. You can close this tab and go back to the chat or terminal.',
  'cliDevice.invalidTitle': 'This link does not work',
  'cliDevice.invalidBody': 'The code in the link is missing or incomplete. Start signing in again from the chat or terminal to get a new link.',
  'cliDevice.notFoundTitle': 'This code was not found',
  'cliDevice.notFoundBody': 'Check that you opened the whole link. If it still does not work, start signing in again from the chat or terminal.',
  'cliDevice.expiredTitle': 'This code has expired',
  'cliDevice.expiredBody': 'A code works for 10 minutes. Start signing in again from the chat or terminal to get a new one.',
  'cliDevice.usedTitle': 'This code was already used',
  'cliDevice.usedBody': 'Each code works only once. If you still need to sign in, start again from the chat or terminal.'
} as const;
